import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';
// We have deprecated emotion. Please use compiled instead
// eslint-disable-next-line no-restricted-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';

import { token } from '@atlaskit/tokens';
import Image from '@atlaskit/image';

import { h300 } from '@confluence/typography-placeholder';

import { CreatePageButton } from '../CreatePageButton';
import RecentEmptyStateDark from '../images/recent/RecentEmptyStateDark.svg';
import RecentEmptyStateLight from '../images/recent/RecentEmptyStateLight.svg';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const EmptyState = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	position: relative;
	height: 128px;
	padding: ${token('space.300', '24px')};
	overflow: hidden;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const Header = styled.div`
	${h300};
	margin: 0 0 ${token('space.100', '8px')};
	line-height: 18px;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const Content = styled.div`
	max-width: 400px;
`;

const imageStyles = css({
	position: 'absolute',
	right: token('space.300', '24px'),
	top: token('space.300', '24px'),
});

const i18n = defineMessages({
	header: {
		id: 'home.views.overview.recent-empty-state.header',
		defaultMessage: 'Get out there and explore',
		description: 'Descriptive header shown when there are not recent pages',
	},
	body: {
		id: 'home.views.overview.recent-empty-state.body',
		defaultMessage: 'Once you visit, edit, or create pages, you’ll find the most recent ones here.',
		description:
			'Descriptive body shown when there are not recent pages indicating how to make pages appear',
	},
});

export const RecentWorkEmptyState = () => {
	return (
		<EmptyState>
			<Content>
				<Header>
					<FormattedMessage {...i18n.header} />
				</Header>
				<FormattedMessage {...i18n.body} />
			</Content>
			<div>
				<CreatePageButton appearance="default" creationLinkSource="home-overview-recentList" />
			</div>
			<Image src={RecentEmptyStateLight} srcDark={RecentEmptyStateDark} css={imageStyles} alt="" />
		</EmptyState>
	);
};
